"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autofill = void 0;
var autofill = {
  login: {
    bank_of_captcha: {
      username: '12345678',
      password: 'TestMyMoney',
      account_type: 'personal',
      captcha: 'D49ZHN'
    },
    bank_of_custom: {
      multiple: true,
      // with_categories does not work

      /* with_categories: {
        username: '12345678',
        password: 'TestMyMoney',
      }, */
      // no_categories seems the same as no_salary

      /* no_categories: {
        username: 'TestBank3937cUGg',
        password: '5epGUMvV',
      }, */
      with_salary: {
        username: 'TestBank4035rY4j',
        password: 's71iaO%9'
      },
      no_salary: {
        username: 'TestBank4036cJpf',
        password: '#jwMMKDw'
      }
    },
    bank_of_mfa: {
      multiple: true,
      cba: {
        username: 'cba',
        password: 'cba',
        'with-mfa': 'with',
        'with-second-mfa': 'none'
      },
      cba_2mfa: {
        username: 'cba',
        password: 'cba',
        'with-mfa': 'with',
        'with-second-mfa': 'cba'
      },
      westpac: {
        username: 'westpac',
        password: 'westpac',
        'with-mfa': 'with',
        'with-second-mfa': 'none'
      },
      hsbc: {
        username: 'hsbc-passwords',
        password: 'hsbc-passwords',
        'with-mfa': 'with',
        'with-second-mfa': 'none'
      },
      hsbc_device: {
        username: 'hsbc-device',
        password: 'hsbc-device',
        'with-mfa': 'with',
        'with-second-mfa': 'none'
      }
    },
    bank_of_mortgage: {
      multiple: true,
      default: {
        username: '12345678',
        password: 'TestMyMoney'
      },
      weekly: {
        username: '7777',
        password: 'weekly'
      },
      fortnightly: {
        username: '1414',
        password: 'fortnightly'
      },
      monthly: {
        username: '3031',
        password: 'monthly'
      }
    },
    bank_of_optmfa: {
      multiple: true,
      with: {
        username: 'with',
        password: 'with',
        date: new Date().toISOString().split('T')[0].replace(/-/g, '')
      },
      without: {
        username: 'without',
        password: 'without',
        date: ''
      }
    },
    bank_of_password: {
      username: '12345678',
      password: 'TestMyMoney'
    },
    bank_of_statements: {
      multiple: true,
      success: {
        username: '12345678',
        password: 'TestMyMoney'
      },
      error: {
        username: '12345678',
        password: 'error'
      }
    }
    /* does not work
    bank_of_transactions: {
     username: '12345678',
     password: 'TestMyMoney',
    }, */

  },
  password: {
    bank_of_password: {
      password: 'TestMyMoney'
    }
  }
};
exports.autofill = autofill;